<arm-dialog (onCancel)="cancel()"
            (onSubmit)="submit()"
            [title]="(data.isEditMode ? 'Edit' : 'Add') + ' FILE REPOSITORY'"
            [disabled]="!mapForm.form.valid|| (!data.isEditMode && !data.selectedItem.file) ||
            (data.selectedItem.fileRepositorySyncSourceType === 'AZURE_FILE_STORAGE' && (!azureForm.form.valid || !updatesForm.form.valid)) ||
            (data.selectedItem.fileRepositorySyncSourceType === 'LOCAL_FILE_PATH' && (!localFileForm.form.valid || !updatesForm.form.valid))">
  <div class="file-repository">
    <mat-tab-group animationDuration="0" class="file-repository-tabs" (selectedTabChange)="onTabChanged($event)">
      <mat-tab [label]="'File Repository Settings'">
        <form #mapForm="ngForm" autocomplete="off">
          <div class="setting-tab-content">
            <arm-form-title>GENERAL</arm-form-title>
            <mat-form-field class="sixtyPerWidth">
              <mat-label>Name</mat-label>
              <input matInput required [(ngModel)]="data.selectedItem.name" maxlength="255" name="name">
              <mat-error>
                Name is <strong>required</strong>
              </mat-error>
            </mat-form-field>

            <div class="settings-section">
              <mat-form-field class="mat-form-field-width">
                <mat-label>Unique Property</mat-label>
                <mat-select required [(ngModel)]="data.selectedItem.unique"
                            (selectionChange)="this.setSelectedUniquePropertyText()"
                            name="file-repository-unique-property-select" [disabled]="data.isEditMode">
                  <mat-option *ngFor="let attr of fileUniquePropOptions"
                              [value]="attr.value">
                    {{attr.text}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <arm-form-title *ngIf="!data.isEditMode">file details</arm-form-title>
            <arm-form-title *ngIf="data.isEditMode">file details and action</arm-form-title>

            <div class="settings-section" *ngIf="data.isEditMode">
              <mat-form-field class="mat-form-field-width">
                <mat-label >File Action</mat-label>
                <mat-select [(ngModel)]="data.selectedItem.fileRepositoryAction " name="fileRepositoryAction">
                  <mat-option *ngFor="let item of actionFileTypesOptions" [value]="item.key">
                    {{item.label}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <mat-checkbox name="file-repository-has-headers" color="primary"
                          [(ngModel)]="data.selectedItem.isFileHasHeaders" [disabled]="data.isEditMode">File has headers
              in the first line
            </mat-checkbox>

            <ac-input-container label="Repository File" class="sixtyPerWidth">
              <ac-file-picker alternativeName="file.repository"
                              (acChanged)="onFileChange($event)"
                              [fileTypeAllowed]="['csv', 'txt']"
                              [filePickerButtonText]="'Browse'">
              </ac-file-picker>
            </ac-input-container>

            <mat-error *ngIf="!data.selectedItem.file && (!data.isEditMode || data.selectedItem.fileRepositorySyncSourceType === 'NO_SCHEDULING')">
              Please upload a file
            </mat-error>

            <mat-form-field class="fileDelimiter">
              <mat-label>File Delimiter</mat-label>
              <mat-select [(ngModel)]="data.selectedItem.delimiter" name="file-repository-delimiter-select">
                <mat-option *ngFor="let delimiter of fileDelimiters" [value]="delimiter">
                  {{delimiter}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-error *ngIf="fileEncodingWarning">
              ARM supports file encoding 'UTF-8'. Uploading a file with a different encoding may cause issues
            </mat-error>
          </div>
        </form>
      </mat-tab>

      <mat-tab [label]="'File Repository Properties'">
        <div class="properties-tab-content">

          <div class="no-file-warning" *ngIf="!data.selectedItem.file && !data.isEditMode">
            <mat-label>Mapping properties are not available, please upload file first</mat-label>
          </div>

          <div class="large-file-warning" *ngIf="data.selectedItem.file && !data.isEditMode && !isFileSizeValid()">
            <mat-label>File size exceeded 1GB, please upload smaller file</mat-label>
          </div>


          <div id="servers-properties-step"
               [hidden]="!(data.selectedItem.file && isFileMappingOptionsReady && isFileSizeValid()) && !data.isEditMode">
            <div class="arm-list-servers-properties">

              <div class="file-mapping-explanation" *ngIf="!data.selectedItem.isFileHasHeaders">
                <mat-label>Select file mapping by column position</mat-label>
              </div>
              <div class="file-mapping-explanation" *ngIf="data.selectedItem.isFileHasHeaders">
                <mat-label>Select file mapping by column header</mat-label>
              </div>

              <div *ngFor="let mapping of this.data.selectedItem.dicAttrMapping;">
                <div class="arm-list-item">
                  <div class="attribute-name">
                    <mat-label>
                      {{mapping.dicAttrName}}
                    </mat-label>
                  </div>

                  <mat-form-field class="ldap-mapping-ad-attr">
                    <mat-label>File mapping</mat-label>
                    <mat-select [(ngModel)]="mapping.fileRepositoryAttrName" name="ldap-mapping-ad-attr"
                                [disabled]="(data.isEditMode && !data.selectedItem.file) || (data.isEditMode && mapping.dicAttrName === this.selectedUniquePropertyText) "
                                *ngIf="data.selectedItem.isFileHasHeaders">
                      <mat-option></mat-option>
                      <mat-option *ngFor="let attr of fileAttributesNames"
                                  [value]="attr">
                        {{attr}}
                      </mat-option>
                    </mat-select>

                    <mat-select [(ngModel)]="mapping.fileRepositoryAttrLocation" name="ldap-mapping-ad-attr"
                                *ngIf="!data.selectedItem.isFileHasHeaders"
                                [disabled]="(data.isEditMode && !data.selectedItem.file) || (data.isEditMode && mapping.dicAttrName === this.selectedUniquePropertyText)">
                      <mat-option></mat-option>
                      <mat-option *ngFor="let attr of fileAttributesLocations"
                                  [value]="attr.value">
                        {{attr.text}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field class="ldap-mapping-normalization"
                                  *ngIf="mapping.dicAttrName !== this.nameProp.dicAttrName">
                    <mat-label>Attribute normalization</mat-label>
                    <mat-select [(ngModel)]="mapping.normalizationGroupId" name="ldap-mapping-normalization"
                                [disabled]="(data.isEditMode && !data.selectedItem.file) || (data.isEditMode && mapping.dicAttrName === this.selectedUniquePropertyText)">
                      <mat-option></mat-option>
                      <mat-option *ngFor="let norm of data.normalizationGroupsOptions"
                                  [value]="norm.id">
                        {{norm.groupName}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="items-divider">
                  <mat-divider></mat-divider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>


      <mat-tab [label]="'File Repository Scheduling Settings'" class="scheduling-settings-tab-content">
        <arm-form-title>Updates</arm-form-title>

        <div class="row-container scheduled-radio-group">
          <div *ngFor="let option of schedulingSourceTypeOptions">
            <label>
              <input type="radio" name="radioGroup" [(ngModel)]="data.selectedItem.fileRepositorySyncSourceType"
                     [value]="option.value">
              {{ option.text }}
            </label>
          </div>
        </div>
        <form #localFileForm="ngForm" autocomplete="off">
          <div *ngIf="data.selectedItem.fileRepositorySyncSourceType==='LOCAL_FILE_PATH'"
               class="local-file-container">
            <div class="row-container">
              <mat-form-field class="local-file-path">
                <mat-label>Repository File Name <strong>(Should be located under /home/armAdmin/)</strong></mat-label>
                <input required type="text" matInput [(ngModel)]="data.selectedItem.localFileName"
                       name="local-file-path"
                       (ngModelChange)="onLocalFileNameChange()">
                <mat-error>
                  Local file name is required
                </mat-error>
              </mat-form-field>
              <ac-button class="ac-dialog-button" (acClick)="verifyPath()">Test</ac-button>
              <div class="test-connection-string">
                <p
                  [ngClass]="{'valid-status': validateFileString.status ==='true', 'error-status': validateFileString.status === 'false'}">{{ validateFileString.string }}</p>
              </div>
            </div>
            <div class="arm-checkbox">
              <mat-checkbox [(ngModel)]="data.selectedItem.validateChecksum"
                            color="primary" name="validateChecksum">
                validate checksum
              </mat-checkbox>
            </div>

            <div class="checksum-info"  *ngIf="data.selectedItem.validateChecksum === true">
              <mat-icon>info</mat-icon>
              <mat-label class="checksum-info-label">"{{fileNameWithoutformat}}.txt" file contains "sha256" checksum must be provided in the same directory.</mat-label>
            </div>
          </div>
        </form>

        <form #azureForm="ngForm" autocomplete="off">
          <div *ngIf="data.selectedItem.fileRepositorySyncSourceType==='AZURE_FILE_STORAGE'"
               class="azure-file-storage-container">
            <mat-form-field class="fullWidth">
              <mat-label>Azure storage connection string</mat-label>
              <input type="text" matInput [(ngModel)]="data.selectedItem.azureStorageConnectionString"
                     name="azure-storage-connection-string"
                     class="fullWidth"
                     required #azureStorageConnectionStringInput="ngModel">
              <mat-error
                *ngIf="azureStorageConnectionStringInput.invalid && azureStorageConnectionStringInput.errors.required">
                Connection String is required
              </mat-error>
            </mat-form-field>

            <div class="row-container">
              <mat-form-field class="container-name">
                <mat-label>Container name</mat-label>
                <input type="text" matInput [(ngModel)]="data.selectedItem.azureStorageContainer"
                       name="Container-name"
                       required #azureStorageContainerInput="ngModel">
                <mat-error *ngIf="azureStorageContainerInput.invalid && azureStorageContainerInput.errors.required">
                  Container name is required
                </mat-error>
              </mat-form-field>

              <mat-form-field class="blob-name">
                <mat-label>Blob name</mat-label>
                <input type="text" matInput [(ngModel)]="data.selectedItem.azureStorageBlob"
                       name="blob-name"
                       required #blobNameInput="ngModel"
                       (ngModelChange)="onAzureBlobNameChange()">
                <mat-error *ngIf="blobNameInput.invalid && blobNameInput.errors.required">
                  Blob name is required
                </mat-error>
              </mat-form-field>
              <ac-button class="ac-dialog-button validate-button" (acClick)="testAzureConnection()">Test Connectivity
              </ac-button>
              <div class="test-connection-string">
                <p
                  [ngClass]="{'valid-status': testConnectionString.status ==='true', 'error-status': testConnectionString.status === 'false'}">{{ testConnectionString.string }}</p>
              </div>
            </div>
            <div class="arm-checkbox">
              <mat-checkbox [(ngModel)]="data.selectedItem.validateChecksum"
                            color="primary" name="validateChecksum">
                validate checksum
              </mat-checkbox>
              <div class="checksum-info"  *ngIf="data.selectedItem.validateChecksum === true">
                <mat-icon>info</mat-icon>
                <mat-label class="checksum-info-label">"{{azureBlobWithoutformat}}.txt" file contains "sha256" checksum must be provided in the same container.</mat-label>
              </div>
            </div>
          </div>

        </form>

        <form #updatesForm="ngForm" autocomplete="off">
          <div *ngIf="data.selectedItem.fileRepositorySyncSourceType !== 'NO_SCHEDULING'">
            <div class="row-container updates-timeouts">
              <mat-form-field class="thirty-percent-width padding-right-ten-pixels">
                <mat-label>File Action</mat-label>
                <mat-select [(ngModel)]="data.selectedItem.fileRepositorySchedulingAction "
                            name="fileRepositorySchedulingAction">
                  <mat-option *ngFor="let item of actionFileTypesOptions" [value]="item.key">
                    {{item.label}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="forty-percent-width padding-right-ten-pixels">
                <mat-label>Check for updates every (hours)</mat-label>
                <input [(ngModel)]="data.selectedItem.syncIntervalHours" matInput
                       min="1" name="syncIntervalHours" type="number"
                       required #syncIntervalHoursInput="ngModel">
                <mat-error *ngIf="syncIntervalHoursInput.invalid && syncIntervalHoursInput.errors.required">
                  updates frequency is required
                </mat-error>
              </mat-form-field>

              <mat-form-field *ngIf="data.selectedItem.fileRepositorySyncSourceType==='AZURE_FILE_STORAGE'"
                              class="thirty-percent-width padding-right-ten-pixels">
                <mat-label>Query Timeout (seconds)</mat-label>
                <input [(ngModel)]="data.selectedItem.queryTimeout" matInput
                       min="1" max="10000" name="queryTimeout" type="number"
                       required #queryTimeoutInput="ngModel">
                <mat-error *ngIf="queryTimeoutInput.invalid && queryTimeoutInput.errors.required">
                  Query Timeout is required
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </form>
      </mat-tab>
    </mat-tab-group>
  </div>
</arm-dialog>
